export enum ResponseTimeoutState {
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
  ABORTING = "ABORTING",
  ABORTED = "ABORTED",
  FINISHED = "FINISHED",
}
